import { translate } from 'react-polyglot';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function UnknownPreview({
  field,
  t
}) {
  return _jsx("div", {
    className: "nc-widgetPreview",
    children: t('editor.editorWidgets.unknownPreview.noPreview', {
      widget: field.get('widget')
    })
  });
}
UnknownPreview.propTypes = {
  field: ImmutablePropTypes.map,
  t: PropTypes.func.isRequired
};
export default translate()(UnknownPreview);